import { Text } from '@mantine/core';
import { useTranslation } from '../../../hooks/useTranslation';
import { getScoreColor } from '../utils/scoreUtils';

interface CircularProgressProps {
    score: number;
    size?: number;
    strokeWidth?: number;
    onDark?: boolean;
}

export const CircularProgress = ({ score, size = 120, strokeWidth = 10, onDark = false }: CircularProgressProps) => {
    const { t } = useTranslation();
    const pct = Math.round(score * 100);
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (pct / 100) * circumference;
    const color = getScoreColor(score);
    const cx = size / 2;
    const cy = size / 2;

    return (
        <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
            <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
                <circle
                    cx={cx}
                    cy={cy}
                    r={radius}
                    fill="none"
                    stroke="rgba(255,255,255,0.15)"
                    strokeWidth={strokeWidth}
                />
                <circle
                    cx={cx}
                    cy={cy}
                    r={radius}
                    fill="none"
                    stroke={color.brandColor}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    transform={`rotate(-90 ${cx} ${cy})`}
                    style={{ transition: 'stroke-dashoffset 0.8s ease' }}
                />
            </svg>
            <div
                style={{
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Text fw={800} style={{ fontSize: size * 0.22, color: onDark ? 'white' : color.brandColor, lineHeight: 1 }}>
                    {pct}%
                </Text>
                <Text size="xs" fw={500} mt={2} style={{ fontSize: size * 0.088, color: onDark ? 'rgba(255,255,255,0.75)' : 'var(--mantine-color-dimmed)' }}>
                    {t(color.labelKey)}
                </Text>
            </div>
        </div>
    );
};


